var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewLogoNoLetters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 126,
    height: 40,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.888 40c11.066 0 20.037-8.954 20.037-20S31.954 0 20.888 0 .85 8.954.85 20s8.971 20 20.038 20z",
    fill: "#ffbc00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 14.86V9.27H0v5.627c.113 0 .213-.037.313-.037 2.75 0 4.988 2.296 4.988 5.14S3.075 25.14.313 25.14C.2 25.14.1 25.115 0 25.103v5.627h42.5v-5.59c-2.75 0-4.987-2.296-4.987-5.14s2.225-5.14 4.987-5.14z",
    fill: "#0d2772"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.55 10.381H8.075v3.194H9.55v-3.194zm0 5.09H8.075v3.194H9.55v-3.194zm0 5.527H8.075v3.194H9.55v-3.194zm0 5.465H8.075v3.194H9.55v-3.194zm25.588-16.082h-1.475v3.194h1.475v-3.194zm0 5.09h-1.475v3.194h1.475v-3.194zm0 5.527h-1.475v3.194h1.475v-3.194zm0 5.465h-1.475v3.194h1.475v-3.194z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewLogoNoLetters);
export default __webpack_public_path__ + "static/media/new-logo-no-letters.de6149728fac1e8303035e2c354b24dc.svg";
export { ForwardRef as ReactComponent };